import { useEffect, useSyncExternalStore } from 'react';

/**
 * A counter that moves whenever a web font becomes usable, so code that
 * MEASURES text outside a Remotion composition (the quote carousel's drag
 * overlay) can re-measure: `useLayerFont` bumps it after adding a FontFace,
 * and `document.fonts` `loadingdone` events bump it too.
 */
let version = 0;
const listeners = new Set<() => void>();

export function bumpFontLoadVersion(): void {
  version += 1;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

const getVersion = () => version;

export function useFontLoadVersion(): number {
  useEffect(() => {
    const fonts = typeof document !== 'undefined'
      ? (document as Document & { fonts?: EventTarget }).fonts
      : undefined;
    if (!fonts?.addEventListener) return undefined;
    fonts.addEventListener('loadingdone', bumpFontLoadVersion);
    return () => fonts.removeEventListener('loadingdone', bumpFontLoadVersion);
  }, []);
  return useSyncExternalStore(subscribe, getVersion, getVersion);
}
